export default __webpack_public_path__ + "static/media/tw-stick.3587aa94.svg";